// extracted by mini-css-extract-plugin
module.exports = {"TilesFeatures":"TilesFeatures_TilesFeatures__PNoqu","paragraph":"TilesFeatures_paragraph__x7KF6","tiles":"TilesFeatures_tiles__67vYl","item":"TilesFeatures_item__exa1L"};